import { ToggleGroup, ToggleGroupItem } from 'components/ui/toggle-group';

type Props = {
    value: string | null | undefined;
    options: { value: string; description: string }[];
    /** Receives `null` when the pressed option is pressed again. Without it the control only displays the value: disabled, but not dimmed. */
    onChange?: (value: string | null) => void;
};

/** The multiplier code as one row of joined segments: grey labels, the pressed one tinted with the text colour. */
export function MultiplierToggle({ value, options, onChange }: Props): JSX.Element {
    return (
        <ToggleGroup
            variant="outline"
            spacing={0}
            disabled={!onChange}
            value={value ? [value] : []}
            onValueChange={(next) => onChange?.(next[0] ?? null)}
        >
            {options.map((option) => (
                <ToggleGroupItem
                    key={option.value}
                    value={option.value}
                    className="border-divider text-grey-900/54 hover:bg-fg/4 hover:text-grey-900/54 aria-pressed:bg-fg/8 aria-pressed:text-fg aria-pressed:hover:bg-fg/12 h-auto p-[7px] text-[0.8125rem] leading-[1.75] font-medium disabled:opacity-100"
                >
                    {option.description}
                </ToggleGroupItem>
            ))}
        </ToggleGroup>
    );
}
